import { Controller } from "@hotwired/stimulus"

// Manages legend item hover interactions and communicates with connected chart(s)
// via Stimulus outlets to coordinate highlight behavior.
// opacity-60 (not -40) keeps faded label text above the 4.5:1 contrast minimum.
const LEGEND_FADE_CLASS = "opacity-60"

export default class extends Controller {
  static outlets = ["chart--highlight"]
  static targets = ["item"]

  highlight(event) {
    const key = event.currentTarget.dataset.seriesKey
    if (!key) return

    this.itemTargets.forEach(item => {
      if (item.dataset.seriesKey !== key) {
        item.classList.add(LEGEND_FADE_CLASS)
      } else {
        item.classList.remove(LEGEND_FADE_CLASS)
      }
    })

    this.chartHighlightOutlets.forEach(chart => chart.highlightSeries(key))
  }

  clearHighlight() {
    this.itemTargets.forEach(item => {
      item.classList.remove(LEGEND_FADE_CLASS)
    })

    this.chartHighlightOutlets.forEach(chart => chart.clearHighlight())
  }
}
